module.exports = __webpack_public_path__ + "static/CouchDB-7c45d007d0780c91557558a7d34664a2.svg";